"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistanceCalcNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const distance_1 = __importDefault(require("@turf/distance"));
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'DISTANCE-CALC';
class DistanceCalcNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            const { firstLatitude, firstLongitude, secondLatitude, secondLongitude } = params;
            const { distanceUnit } = this.config ? this.config : { distanceUnit: 'kilometers' };
            if (firstLatitude && firstLongitude && secondLatitude && secondLongitude) {
                const dist = distance_1.default({ type: 'Point', coordinates: [Number(firstLongitude), Number(firstLatitude)] }, { type: 'Point', coordinates: [Number(secondLongitude), Number(secondLatitude)] }, { units: distanceUnit || 'kilometers' });
                return {
                    [`output`]: isNaN(dist) ? null : dist,
                };
            }
            return {
                [`output`]: null,
            };
        };
        //TODO: Build the interface definition from the given schema....but what is our schema
        this._interfaceDefinition = Schema;
    }
}
exports.DistanceCalcNode = DistanceCalcNode;
DistanceCalcNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Distance Calc',
    isIdempotent: true,
    primaryCategory: 'Geography',
};
//# sourceMappingURL=DistanceCalc.js.map